var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBuilding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 5.89166C12.5 5.33333 12.225 4.81666 11.7583 4.50833L8.425 2.28333C7.86667 1.90833 7.13333 1.90833 6.575 2.28333L3.24167 4.50833C2.78333 4.81666 2.5 5.33333 2.5 5.89166V10.625C2.5 10.8583 2.68333 11.0417 2.91667 11.0417H12.0833C12.3167 11.0417 12.5 10.8583 12.5 10.625V5.89166ZM7.5 8.95832C6.7 8.95832 6.04167 8.29999 6.04167 7.49999C6.04167 6.69999 6.7 6.04166 7.5 6.04166C8.3 6.04166 8.95833 6.69999 8.95833 7.49999C8.95833 8.29999 8.3 8.95832 7.5 8.95832Z",
    fill: "#0F55DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 17.7084H17.2748V15.2084C18.0665 14.95 18.6415 14.2083 18.6415 13.3333V11.6667C18.6415 10.575 17.7498 9.68335 16.6582 9.68335C15.5665 9.68335 14.6748 10.575 14.6748 11.6667V13.3333C14.6748 14.2 15.2415 14.9333 16.0165 15.2V17.7084H12.4998V12.7083C12.4998 12.475 12.3165 12.2917 12.0832 12.2917H2.9165C2.68317 12.2917 2.49984 12.475 2.49984 12.7083V17.7084H1.6665C1.32484 17.7084 1.0415 17.9917 1.0415 18.3334C1.0415 18.675 1.32484 18.9584 1.6665 18.9584H16.6082C16.6248 18.9584 16.6332 18.9667 16.6498 18.9667C16.6665 18.9667 16.6748 18.9584 16.6915 18.9584H18.3332C18.6748 18.9584 18.9582 18.675 18.9582 18.3334C18.9582 17.9917 18.6748 17.7084 18.3332 17.7084ZM6.87484 15.2084C6.87484 14.8667 7.15817 14.5833 7.49984 14.5833C7.8415 14.5833 8.12484 14.8667 8.12484 15.2084V17.7084H6.87484V15.2084Z",
    fill: "#0F55DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuilding);
export default __webpack_public_path__ + "static/media/building.78f44f357bf8ba550d78f185db0d5fec.svg";
export { ForwardRef as ReactComponent };